import { capitalize } from 'lodash';

import { setOrganizationFullAddress } from 'src/utils/escrow';
import { TableFooter, Table, TableBody, TableCell, TableRow } from '@/components/ui/table';
import { Card, CardHeader, CardContent, CardDescription, CardTitle } from '@/components/ui/card';
import { usePartySuggestChanges } from 'src/context/suggest-changes';
import { OrganizationRegistrationNumberTooltip } from 'src/components/Organization';

import EditDepositorDialog from './EditDepositorDialog';

const PartyOrganization = () => {
  const { organization: suggestedOrganization, partyType } = usePartySuggestChanges();

  const address = {
    street: suggestedOrganization?.street || '',
    streetNumber: suggestedOrganization?.streetNumber || '',
    city: suggestedOrganization?.city || '',
    postalCode: suggestedOrganization?.postalCode || '',
    region: suggestedOrganization?.region || '',
    country: suggestedOrganization?.country || '',
  };

  const rows = [
    {
      key: 'organizationName',
      label: 'Organization Name',
      value: suggestedOrganization?.companyName,
    },
    {
      key: 'website',
      label: 'Website',
      value: suggestedOrganization?.companyWebsite || '-',
    },
    {
      key: 'registrationNumber',
      label: (
        <div className="flex items-center justify-between gap-1">
          Registration Number
          <OrganizationRegistrationNumberTooltip />
        </div>
      ),
      value: suggestedOrganization?.companyRegistration || '-',
    },
    {
      key: 'address',
      label: 'Address',
      value: setOrganizationFullAddress(address),
    },
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle>{capitalize(partyType)} organization details</CardTitle>
        <CardDescription>
          What are your company&apos;s details?
          <br />
          This includes the registered name and address of the entity, which will be listed in the escrow agreement.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <Table>
          <TableBody>
            {rows.map(({ key, label, value }) => (
              <TableRow key={key}>
                <TableCell className="font-medium text-muted-foreground w-[190px]">{label}</TableCell>
                <TableCell className="w-[85px]">:</TableCell>
                <TableCell>{value}</TableCell>
              </TableRow>
            ))}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TableCell colSpan={3}>
                <div className="flex justify-end">
                  <EditDepositorDialog />
                </div>
              </TableCell>
            </TableRow>
          </TableFooter>
        </Table>
      </CardContent>
    </Card>
  );
};

export default PartyOrganization;
